import React, {useEffect, useRef, useState} from 'react'
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";

const ShowSingleCard = ({
                            card,
                            selectedCard,
                            setSelectedCard,
                            settings,
                        }) => {

    const [initialStep, setInitialStep] = useState(true);
    const [firstImage, setFirstImage] = useState(null);

    useEffect(() => {
        extractFirstImage(card);
    }, [initialStep]);

    const extractFirstImage = (card) => {
        const imageLayer = card?.layers?.find(layer => layer?.isImageLayer);
        const firstChildImage = imageLayer?.children[0] || null;
        setFirstImage(firstChildImage);
    }
    
    return (
        <>
            <div className={'p-3 flex justify-start items-center'}>
                {firstImage &&
                    <ProductImageSmall
                        afterImageSelected={(event) => {
                            setSelectedCard(card);
                        }}
                        isSelected={selectedCard?.key === card?.key}
                        dimension={75}
                        imageUrl={firstImage?.url}/>
                }

                <div
                    onClick={() => {
                        setSelectedCard(card);
                    }}
                    className={'text-purple-500 cursor-pointer font-semibold ml-2'}>{card?.name}</div>
            </div>
        </>
    )
}

export default ShowSingleCard
